import React from "react";
import { SurveyTxt } from "../../SurveyTxt";
import { Card } from "../../designSystem/Card";
import { MessageCard } from "../../designSystem/Message";
import { H2 } from "../../designSystem/typography/Heading";

type SurveyDoneViewProps = { txt: SurveyTxt }
export function SurveyDoneView(props: SurveyDoneViewProps): JSX.Element {
    return (
        <div>
            <H2>{props.txt.overview_surveyCompleted_header}</H2>
            <Card variant="outlined">
                <MessageCard variant="success">
                    {props.txt.overview_surveyCompleted}
                </MessageCard>
            </Card>
        </div>
    );
}